import { FC, useMemo } from 'react';

import { useBrand } from 'hooks/useBrand';
import { isGardenaBrand } from 'utils/brandUtils';
import { Container, ImageContainer, ImageContainerGardena } from './styled';

export const Carousel: FC = () => {
  const { brand, brandConfig } = useBrand();
  const { slideshowImages } = brandConfig;
  const isGardena = isGardenaBrand(brand);

  const imageCarousel = useMemo(() => {
    const Component = isGardena ? ImageContainerGardena : ImageContainer;

    return slideshowImages.map((imageUrl, index) => (
      <Component
        key={imageUrl}
        $backgroundUrl={imageUrl}
        $index={index}
        $zIndex={slideshowImages.length - index}
        data-testid="carousel-image"
      />
    ));
  }, [slideshowImages, isGardena]);

  return <Container>{imageCarousel}</Container>;
};
